<template>
    <div class="modal">
        <div class="modal__container" v-if="isOpen">
            <div class="modal__dialog">
                <slot></slot>
            </div>
        </div>
        <a class="modal__close" v-bind:class="{ 'is-open' : isOpen }" v-on:click="closeModal"></a>
        <div class="modal__backdrop" v-bind:class="{ 'is-open' : isOpen }" v-on:click="closeModal"></div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                isOpen: false,
            }
        },
        methods: {
            closeModal: function () {
                this.isOpen = false;

                document.querySelector('body').classList.remove('has-modal-open');
            },
            openModal: function (id) {
                if (this.id === id) {
                    this.isOpen = true;

                    document.querySelector('body').classList.add('has-modal-open');
                }
            }
        },
        mounted: function () {
            eventBus.$on('open-modal', this.openModal);
        },
        props: {
            id: {
                required: true,
                type: String
            },
        }
    }
</script>